var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.46341 0C1.17576 0 0.911732 0.088575 0.685976 0.234375L9.34451 7.7422C9.74088 8.08628 10.2751 8.08623 10.6707 7.7422L19.314 0.234375C19.0883 0.088575 18.8242 0 18.5366 0H1.46341ZM0.0838536 1.0078C0.0316584 1.1623 0 1.32687 0 1.5V11.5C0 11.8012 0.088317 12.078 0.236293 12.3125L6.43293 6.52345L0.0838536 1.0078ZM19.9161 1.0078L13.5823 6.51562L19.7637 12.3125C19.9117 12.078 20 11.8012 20 11.5V1.5C20 1.32687 19.9683 1.1623 19.9161 1.0078ZM12.8354 7.17188L11.2957 8.5078C10.5511 9.15535 9.45663 9.1544 8.7119 8.5078L7.17988 7.1797L1.02898 12.9297C1.16661 12.9734 1.31141 13 1.46341 13H18.5366C18.6886 13 18.8334 12.9734 18.971 12.9297L12.8354 7.17188Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.59593cfa23ea52b659cb268ca260301d.svg";
export { ForwardRef as ReactComponent };